export default __webpack_public_path__ + "static/media/kkanji.8950833b.png";